module.exports = __webpack_public_path__ + "static/orthodontics2-080427303051600ce655b0cf9259ec90.jpg";